<template>

    <div class="rendezvous-grid">
        <div class="grid-item">

            <h3 class="steps-header">
                {{getHeading}}
            </h3>

            <p>{{getCopy}}</p>

        </div>
    </div>

</template>

<script>

    import {mapState} from 'vuex'
    import {sprintf} from 'sprintf-js'

    export default {
        name: 'TVERendezvousConfirmation',
        computed: {

            ...mapState('pageAttributes', {
                pageAttr: state => state.attributes
            }),

            ...mapState('flow', {
                flow: state => state.config,
                deviceName: state => state.config.rendezvous ? state.config.rendezvous.displayName : null,
            }),

            getHeading() {
                return sprintf(this.pageAttr.tve_rendezvous_confirmation_heading, this.deviceName)
            },

            getCopy() {
                return sprintf(this.pageAttr.tve_rendezvous_confirmation_text, this.deviceName)
            },

        },
        methods: {},
    }
</script>
